/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { TICKET_CATEGORIES } from '../constants';

export const createTicketRequestSchema = z.object({
  category: z.enum(TICKET_CATEGORIES),
  message: z.string().min(1).max(2000),
});

export type ICreateTicketRequest = z.infer<typeof createTicketRequestSchema>;
